import layoutHeaderAside from '@/layouts/HeaderAside'

const meta = {auth: true}
export default {
  path: '/transportService',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/transportService/track/trackGnys',
      name: 'trackGnys',
      component: () => import('@/pages/transportService/trackGnys/index.vue'),
      meta: {
        ...meta,
        title: '国内货物追踪',
        // requireAuth: true
      },
    },
    {
      path: '/transportService/track/trackGlyd',
      name: 'trackGlyd',
      component: () => import('@/pages/transportService/trackGlyd/index.vue'),
      meta: {
        ...meta,
        title: '国联货物追踪',
        // requireAuth: true
      },
    },
    {
      path: '/transportService/trackGoods',
      name: 'trackGoods',
      component: () => import('@/pages/transportService/trackGoods/index.vue'),
      meta: {
        ...meta,
        title: '货物到达预测',
        requireAuth: true
      }
    },
    {
      path: '/transportService/loadingTruck',
      name: 'loadingTruck',
      component: () => import('@/pages/transportService/loadingTruck.vue'),
      meta: {
        ...meta,
        title: '装卸车信息',
        requireAuth: true
      }
    },
    {
      path: '/transportService/freightInquiry',
      name: 'freightInquiry',
      component: () => import('@/pages/transportService/freightInquiry.vue'),
      meta: {
        ...meta,
        title: '运费查询',
        requireAuth: true
      }
    },
    {
      path: '/transportService/cargoClaims',
      name: 'cargoClaims',
      component: () => import('@/pages/transportService/cargoClaims.vue'),
      meta: {
        ...meta,
        title: '货损处理',
        requireAuth: true
      }
    },
    {
      path: '/transportService/claimsApply',
      name: 'claimsApply',
      component: () => import('@/pages/transportService/components/claimsApply.vue'),
      meta: {
        ...meta,
        title: '发起理赔',
        requireAuth: true
      }
    },
    {
      path: '/transportService/claimsDetail',
      name: 'claimsDetail',
      component: () => import('@/pages/transportService/components/claimsDetail.vue'),
      meta: {
        ...meta,
        title: '理赔详情',
        requireAuth: true
      }
    },
  ]
}
